var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { REACT_APP_SPLIT_IO_KEY } from './env';
import { FeatureFlagContext } from './FeatureFlagContext';
import { useSplitClientFactoryData } from './useSplitClientFactoryData';
import { isInternalUser, getStatus } from './utils';
/**
 * This provider should be included ONCE in an application. It allows for the usage of useFeatureFlag inside it.
 * Split.io will get ALL flags data from its api once this Provider loads
 */
export var FeatureFlagProvider = function (_a) {
    var flagUser = _a.flagUser, children = _a.children, authorizationKeyFromProps = _a.authorizationKey;
    var memoizedFlagUser = useMemo(function () { return (__assign(__assign({}, flagUser), { isInternalUser: isInternalUser(flagUser.email) })); }, [flagUser]);
    var authorizationKey = authorizationKeyFromProps || REACT_APP_SPLIT_IO_KEY;
    var _b = useSplitClientFactoryData({
        flagUser: memoizedFlagUser,
        authorizationKey: authorizationKey
    }), client = _b.client, factory = _b.factory, lastUpdate = _b.lastUpdate;
    var value = useMemo(function () { return ({
        client: client,
        factory: factory,
        lastUpdate: lastUpdate,
        flagUser: memoizedFlagUser,
        status: getStatus(client)
    }); }, [factory, client, lastUpdate, memoizedFlagUser]);
    return (React.createElement(FeatureFlagContext.Provider, { value: value }, children));
};
//# sourceMappingURL=FeatureFlagProvider.js.map